import React from 'react';
import {object} from 'prop-types';

import classes from './PanelInsert.module.css';

const EquipmentItemPanelInsert = ({node}) => {
    return (
        <dl className={classes.agentInfo}>
            <dt>Name</dt>
            <dd>{node.name}</dd>

            <dt>Site</dt>
            <dd>{node.siteName}</dd>

            <dt>Equipment Type</dt>
            <dd>{node.equipmentType.name}</dd>

            <dt>Manufacturer</dt>
            <dd>{node.manufacturer ? node.manufacturer.name : ''}</dd>

            <dt>Model Number</dt>
            <dd>{node.model}</dd>

            <dt>Serial Number</dt>
            <dd>{node.serialNumber}</dd>
        </dl>
    );
};

EquipmentItemPanelInsert.defaultProps = {
    node: {}
};

EquipmentItemPanelInsert.propTypes = {
    node: object.isRequired
};

export default EquipmentItemPanelInsert;
